<template>
    <v-progress-circular v-if="!token" indeterminate color="primary"></v-progress-circular>
    <div class="mt-5" v-else>
        <p v-if="funeralHome">Account ID: {{ funeralHome.funeralHome.externalId }}</p>
        <!-- MS Section -->
        <div v-if="msApiKey">
            <div class="mb-5" id="tukiosCard">
                <div class="img-div">
                    <div class="logo-div">
                        <v-img
                            class="mb-4"
                            src="../../assets/images/logo.png"
                            max-width="80"
                            contain
                            alt="Ms Api Logo"
                        ></v-img>
                    </div>
                </div>
                <div class="input-div">
                    <v-btn v-if="!msApiKey" class="mb-2" outlined color="indigo" @click="updateMsKey">
                        Generate API Key
                    </v-btn>
                    <p>
                        MemoryShare offers a Partner API that allows any software vendor to add and modify services
                        within MemoryShare. If you are interested in integrating with MemoryShare, please see
                        <a
                            style="text-decoration: underline; color: #1877f2 !important"
                            href="https://memoryshare.notion.site/MemoryShare-Public-API-Documentation-11284502c6d280129acaccd95c276c7e"
                            target="_blank"
                            >the docs</a
                        >
                        or email
                        <a
                            style="text-decoration: underline; color: #1877f2 !important"
                            href="mailto:developer@memoryshare.com"
                            >developer@memoryshare.com</a
                        >.
                    </p>
                    <div class="connection-entry" @click="copyText(msApiKey)" v-if="msApiKey">
                        <span class="entry-title">API KEY</span>
                        <div class="content">
                            {{ msApiKey }}
                            <v-icon slot="append" class="icon">mdi-clipboard</v-icon>
                        </div>
                    </div>
                    <div class="d-flex justify-end">
                        <v-btn @click="revokeMemoryShareAPIKey" color="primary">Revoke API Key</v-btn>
                    </div>
                </div>
                <!-- <v-divider class="my-6"></v-divider> -->
            </div>
        </div>

        <!-- Ms Modal -->
        <v-dialog v-model="msModal" max-width="500px">
            <v-card class="p-3">
                <v-card-title>Generate API Key</v-card-title>
                <v-card-text>Generate key for use with MemoryShare API </v-card-text>

                <div class="text-center">
                    <v-btn @click="generateMemoryShareAPIKey" color="primary">Generate API Key</v-btn>
                </div>
            </v-card>
        </v-dialog>
        <!-- End Ms Modal -->

        <!-- End Ms Section -->

        <!-- Passare Section -->
        <div id="passareCard" class="mb-5" v-if="linkedPassare">
            <div class="img-div">
                <div class="logo-div">
                    <v-img
                        class="mb-4"
                        src="../../assets/images/passare-logo-2.png"
                        contain
                        max-width="180"
                        alt="Passare Logo"
                    ></v-img>
                </div>
                <div class="img-text">
                    <p class="text-center">
                        MemoryShare is now integrated with Passare. Any service you create in Passare will automatically
                        populate inside your MemoryShare dashboard.
                    </p>
                </div>
            </div>
            <div class="input-div">
                <div class="text-div">
                    <v-text-field
                        disabled
                        v-model="passare.passareOrganizationName"
                        label="Organization Name"
                    ></v-text-field>
                    <v-text-field
                        disabled
                        v-model="passare.passareOrganizationId"
                        label="Organization ID"
                        required
                    ></v-text-field>

                    <v-text-field
                        disabled
                        type="password"
                        v-model="passare.passareToken"
                        label="API Key"
                        required
                    ></v-text-field>
                </div>
                <div>
                    <div class="text-center button-div">
                        <div class="d-flex justify-content-center">
                            <v-switch
                                :disabled="this.loading"
                                hide-details
                                v-model="importPassareEvents"
                                label="Import Events"
                            ></v-switch>
                        </div>
                        <!-- <p v-if="passare.lastSyncDate" class="sync-info">Last synced on {{ passare.lastSyncDate }}</p> -->

                        <p class="sync-info">{{ passare.totalServices }} services synced</p>

                        <div class="mt-4 text-center">
                            <v-btn depressed @click="passareDisconnectModal = true">Disconnect</v-btn>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Passare Modal -->
        <v-dialog v-model="passareModal" max-width="500px">
            <v-card class="p-3">
                <div style="display: flex">
                    <h5>Passare Integration</h5>
                    <v-spacer></v-spacer>
                    <font-awesome-icon @click="passareModal = false" class="btn" icon="fa-regular fa-circle-x" />
                </div>
                <div v-if="!settings.timeZone || !settings.defaultUser">
                    <div class="" v-if="!settings.timeZone">
                        <v-card-text>Please update timezone settings to use this feature.</v-card-text>
                        <v-card-text
                            >1. Navigate to
                            <strong
                                ><settings-icon size="1.25x" /> >
                                <a v-if="$auth.role.includes('FuneralHome')" href="/settings">Home</a>
                                <a v-else :href="'/homes/settings/' + funeralHomeId + '?tab=details'"
                                    >Details</a
                                > </strong
                            ><br />
                            2. Select a timezone from <strong>Timezone</strong> drop down menu.<br />
                            3. Select <strong>Save Home</strong>
                        </v-card-text>
                    </div>
                    <div v-if="!settings.defaultUser">
                        <v-card-text>Please select a default user to use this feature.</v-card-text>
                        <v-card-text
                            >1. Navigate to
                            <strong
                                ><settings-icon size="1.25x" /> >
                                <a v-if="$auth.role.includes('FuneralHome')" href="/settings">Home</a>
                                <a v-else :href="'/homes/settings/' + funeralHomeId + '?tab=details'"
                                    >Details</a
                                > </strong
                            ><br />
                            2. Select a user from <strong>Default User</strong> drop down menu.<br />
                            3. Select <strong>Save Home</strong>
                        </v-card-text>
                    </div>
                </div>
                <div v-else>
                    <v-card-text v-if="organizationList.length > 0" class="text-center p-3"
                        >This API Key is linked to multiple accounts, please select an account.</v-card-text
                    >
                    <v-text-field
                        v-if="organizationList.length < 1"
                        v-model="passare.passareToken"
                        label="API Key"
                    ></v-text-field>
                    <v-data-table
                        v-if="organizationList.length > 0"
                        :items="organizationList"
                        :headers="organizationListHeaders"
                        @click:row="linkOrganization"
                    ></v-data-table>

                    <div v-if="organizationList.length < 1" style="display: flex; justify-content: space-between">
                        <v-btn @click="requestKey()">Request API Key</v-btn>
                        <v-btn
                            v-if="organizationList.length < 1"
                            :disabled="settings.timeZone == null"
                            color="primary"
                            @click="checkAPIKey(passare.passareToken)"
                            >Connect</v-btn
                        >
                    </div>
                </div>
            </v-card>
        </v-dialog>
        <!-- End Passare Modal -->

        <!-- Passare Disconnect Modal -->
        <v-dialog v-model="passareDisconnectModal" max-width="500px">
            <v-card class="p-3">
                <v-card-title class="p-0">Are you sure?</v-card-title>
                <v-card-text>This will stop syncing with Passare services.</v-card-text>
                <div class="text-center">
                    <v-btn dark color="red" @click="disconnectPassare">Disconnect</v-btn>
                </div>
            </v-card>
        </v-dialog>
        <!-- End Passare Disconnect Modal -->

        <!-- End Passare Section -->

        <!-- Facebook Section -->
        <v-form v-if="facebookLink" v-model="formIsValid" ref="facebookForm" @submit.prevent="updateFacebook">
            <div class="mb-3" id="facebookCard">
                <div
                    style="display: flex; flex-direction: column; align-items: center; padding: 5px; padding-top: 15px"
                >
                    <v-img
                        class="facebook-logo mb-4"
                        src="../../assets/images/facebook.png"
                        alt="Facebook Logo"
                        style="min-width: 120px"
                    ></v-img>
                    <p class="text text-center">Integrate with Facebook</p>
                </div>
                <div class="input-div">
                    <div class="text-div">
                        <v-text-field
                            v-model="tempFacebookRtmps"
                            :rules="rtmpRule"
                            label="Server URL"
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="tempFacebookStreamKey"
                            label="Facebook Stream Key"
                            :rules="[v => !!v || 'This field is required']"
                            required
                        ></v-text-field>
                    </div>
                    <div class="button-div">
                        <v-btn
                            class="ml-2"
                            width="138px"
                            :disabled="updateDisabled || !formIsValid"
                            color="primary"
                            @click="updateFacebook"
                            >Update</v-btn
                        >
                        <v-btn class="ml-2" @click="disconnectFacebookModal = true">Disconnect</v-btn>
                    </div>
                </div>
            </div>
            <!-- <v-divider class="my-6"></v-divider> -->
        </v-form>

        <!-- Facebook Modal -->
        <v-dialog v-model="facebookModal" max-width="500px">
            <v-form v-model="formIsValid">
                <v-card class="p-3">
                    <v-card-title class="p-0">Facebook Integration</v-card-title>
                    <v-text-field
                        v-model="tempFacebookRtmps"
                        :rules="rtmpRule"
                        label="Facebook RTMPS"
                        required
                    ></v-text-field>
                    <v-text-field
                        v-model="tempFacebookStreamKey"
                        :rules="[v => v.length > 10 || 'Invalid Stream Key']"
                        label="Facebook Stream Key"
                        required
                    ></v-text-field>

                    <div class="text-center">
                        <v-btn :dark="formIsValid" color="primary" @click="updateFacebook" :disabled="!formIsValid"
                            >Connect</v-btn
                        >
                    </div>
                </v-card>
            </v-form>
        </v-dialog>

        <!-- End Facebook Modal -->

        <!-- Facebook Disconnect Modal -->
        <v-dialog v-model="disconnectFacebookModal" max-width="500px">
            <v-card class="p-3">
                <v-card-title class="p-0">Are you sure?</v-card-title>
                <v-card-text>This will end connection with facebook stream link.</v-card-text>

                <div class="text-center">
                    <v-btn dark color="red" @click="disconnectFacebookLink">Disconnect</v-btn>
                </div>
            </v-card>
        </v-dialog>
        <!-- End Facebook Disconnect Modal -->

        <!-- End Facebook Section -->

        <!-- Get Started Section -->
        <v-row class="mb-4">
            <v-col style="display: flex; justify-content: space-evenly; flex-wrap: wrap">
                <div v-if="!msApiKey" class="get-started-div" @click="msModal = true">
                    <v-img src="../../assets/images/logo.png" max-width="80" contain alt="Ms Logo"></v-img>
                    <p class="text-overline">API</p>
                </div>

                <div v-if="!linkedPassare" class="get-started-div" @click="passareModal = true">
                    <!-- <p class="elevation-2 beta-badge">Beta</p> -->

                    <v-img
                        src="../../assets/images/passare-logo-2.png"
                        contain
                        min-width="170"
                        alt="Passare Logo"
                    ></v-img>
                    <!-- <v-btn :disabled="settings.timeZone == null" @click="passareModal = true" color="primary"
                        >Get Started</v-btn
                    > -->
                </div>

                <div v-if="!facebookLink" class="get-started-div" @click="facebookModal = true">
                    <v-img
                        min-width="70px"
                        class="facebook-logo mb-2 mt-2"
                        src="../../assets/images/facebook.png"
                        alt="Facebook Logo"
                    ></v-img>
                    <!-- <v-btn @click="facebookModal = true" color="primary">Get Started</v-btn> -->
                </div>
            </v-col>
        </v-row>

        <!-- End Get Started Section -->
        <!-- <v-form @submit.prevent="updateZapier">
            <div style="display: flex; flex-direction: column; align-items: flex-start; margin-top: 40px">
                <p style="margin-left: 70px" class="elevation-2 coming-soon-badge">Coming soon</p>
                <svg
                    class="mb-4"
                    width="80"
                    height="37"
                    viewBox="0 0 80 37"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="rgb(255, 74, 0)"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M53.9335 4.18463H50.9949L53.0729 2.11208C52.9095 1.88325 52.7272 1.66852 52.5286 1.47051C52.3301 1.2725 52.1154 1.09121 51.8859 0.928209L49.808 3.00076V0.069825C49.5361 0.024372 49.2564 0.000339343 48.972 -0.000183105H48.9662C48.6813 0.000339343 48.4021 0.024372 48.1302 0.069825V3.00076L46.0523 0.928209C45.8228 1.09121 45.6076 1.2725 45.4095 1.47051L45.4085 1.47156C45.21 1.66904 45.0282 1.88325 44.8653 2.11208L46.9433 4.18463H44.0047C44.0047 4.18463 43.9345 4.73477 43.9345 5.01951V5.02316C43.9345 5.30737 43.9586 5.58688 44.0047 5.85856H46.9433L44.8653 7.93059C45.1922 8.38826 45.5934 8.78897 46.0523 9.11446L48.1302 7.0419V9.97284C48.4021 10.0183 48.6807 10.0423 48.9652 10.0429H48.9725C49.2569 10.0423 49.5366 10.0183 49.808 9.97284V7.0419L51.8865 9.11446C52.1154 8.95198 52.3301 8.77017 52.5286 8.57216H52.5292C52.7272 8.37415 52.9095 8.15942 53.0729 7.93059L50.9944 5.85856H53.9335C53.9791 5.58741 54.0032 5.30894 54.0032 5.02473V5.01794C54.0032 4.73373 53.9791 4.45578 53.9335 4.18463ZM58.8497 25.5304C58.0105 24.7441 57.571 23.5038 57.5302 21.8095H68.1148C68.1347 21.588 68.1551 21.3215 68.175 21.0081C68.1955 20.6956 68.206 20.3984 68.206 20.1157C68.206 19.087 68.064 18.1346 67.7811 17.2574C67.4978 16.3802 67.0834 15.6242 66.5381 14.9889C65.9918 14.3536 65.3145 13.8547 64.5058 13.4916C63.697 13.1285 62.7568 12.9467 61.6856 12.9467C60.4316 12.9467 59.3447 13.1635 58.4249 13.5971C57.5051 14.0313 56.7419 14.6159 56.1353 15.3515C55.5292 16.0882 55.0788 16.9549 54.786 17.9528C54.4926 18.9517 54.346 20.0253 54.346 21.1742C54.346 22.3445 54.4979 23.4181 54.8011 24.3961C55.1044 25.3742 55.5848 26.2216 56.2416 26.9373C56.8985 27.6531 57.7329 28.2074 58.7439 28.6008C59.7543 28.9942 60.9674 29.1907 62.3833 29.1907C63.3534 29.1907 64.2376 29.1196 65.0369 28.9791C65.8347 28.8375 66.568 28.6264 67.2353 28.3438C67.2149 27.9201 67.1547 27.4922 67.0536 27.058C66.952 26.6244 66.821 26.2566 66.6591 25.9541C65.3648 26.4582 64.0008 26.7106 62.565 26.7106C60.9271 26.7106 59.6888 26.3167 58.8497 25.5304ZM30.5092 13.3096C30.7109 13.2699 30.9183 13.2396 31.1305 13.2192C31.3431 13.1993 31.56 13.1889 31.7826 13.1889C31.9843 13.1889 32.1969 13.1993 32.4195 13.2192C32.6416 13.2396 32.8543 13.2699 33.0565 13.3096C33.0764 13.3508 33.1021 13.4762 33.1319 13.6883C33.1623 13.8999 33.1927 14.1267 33.2231 14.3686C33.2535 14.6105 33.2838 14.843 33.3142 15.0645C33.3446 15.2865 33.3593 15.4276 33.3593 15.4882C33.5615 15.1653 33.804 14.8529 34.0874 14.5504C34.3702 14.2479 34.7096 13.9752 35.1035 13.7338C35.4975 13.4914 35.9422 13.3002 36.4382 13.1591C36.9327 13.018 37.4837 12.947 38.0908 12.947C39.0002 12.947 39.8445 13.0985 40.6235 13.401C41.4013 13.7035 42.0681 14.1721 42.6244 14.8069C43.1802 15.4427 43.6149 16.2494 43.9287 17.2269C44.2419 18.206 44.3985 19.3595 44.3985 20.6907C44.3985 23.3526 43.6757 25.4351 42.2305 26.9371C40.7843 28.4397 38.7377 29.191 36.0888 29.191C35.6441 29.191 35.1895 29.1607 34.7243 29.1001C34.2586 29.0395 33.8548 28.9585 33.5112 28.8582V35.9666C33.2686 36.0063 33.0109 36.0366 32.738 36.057C32.4651 36.0768 32.2168 36.0873 31.9947 36.0873C31.7721 36.0873 31.5249 36.0768 31.252 36.057C30.9791 36.0366 30.7313 36.0063 30.5092 35.9666V13.3096ZM24.2918 18.6036C24.2918 17.4135 23.9885 16.5869 23.382 16.123C22.7754 15.6596 21.8959 15.4276 20.7435 15.4276C20.0353 15.4276 19.3738 15.4835 18.7572 15.5938C18.1402 15.705 17.5383 15.8508 16.9527 16.0321C16.5682 15.3665 16.3765 14.5708 16.3765 13.6424C17.0632 13.4209 17.8212 13.2495 18.6509 13.1283C19.4796 13.0071 20.2779 12.947 21.0468 12.947C23.0682 12.947 24.605 13.4063 25.6563 14.3232C26.7076 15.2411 27.2335 16.7082 27.2335 18.7243V28.4345C26.5259 28.596 25.6668 28.7621 24.6559 28.9335C23.6444 29.1043 22.613 29.1905 21.5622 29.1905C20.5712 29.1905 19.677 29.1001 18.8782 28.9183C18.0794 28.7365 17.4021 28.445 16.8464 28.0406C16.2901 27.6383 15.8606 27.1232 15.5573 26.4983C15.254 25.8735 15.1026 25.1175 15.1026 24.2293C15.1026 23.3631 15.2791 22.6014 15.6332 21.9457C15.9868 21.2911 16.4671 20.7462 17.0737 20.3125C17.6803 19.8794 18.378 19.556 19.1663 19.3449C19.9552 19.1328 20.7839 19.0268 21.6534 19.0268C22.3003 19.0268 22.8309 19.0425 23.2452 19.0722C23.6596 19.1031 24.0084 19.1381 24.2918 19.1783V18.6036ZM0.666687 28.4045L8.8554 15.6996H1.63731C1.57654 15.3365 1.54616 14.9337 1.54616 14.4896C1.54616 14.0664 1.57654 13.6725 1.63731 13.3094H13.3135L13.4649 13.7033L5.21597 26.438H12.9495C13.0097 26.8419 13.0406 27.2546 13.0406 27.6778C13.0406 28.0822 13.0097 28.4646 12.9495 28.8282H0.818592L0.666687 28.4045ZM23.1394 21.417C23.6046 21.4577 23.9885 21.4974 24.2918 21.5377V26.4685C23.9073 26.5694 23.4679 26.6446 22.9723 26.6948C22.4773 26.746 21.997 26.771 21.5319 26.771C21.1683 26.771 20.7839 26.7512 20.3795 26.7104C19.9751 26.6697 19.6063 26.5589 19.2727 26.3776C18.939 26.1958 18.6609 25.9341 18.4388 25.5908C18.2156 25.2486 18.1051 24.7742 18.1051 24.1692C18.1051 23.222 18.433 22.5162 19.0909 22.0518C19.7472 21.5883 20.7027 21.3559 21.9567 21.3559C22.2799 21.3559 22.6743 21.3768 23.1394 21.417ZM34.6939 26.5892C34.2895 26.5291 33.8946 26.4283 33.5112 26.2867V19.9953C33.5112 19.2284 33.6222 18.5691 33.8454 18.0137C34.0675 17.4594 34.3603 17.0001 34.7243 16.637C35.0884 16.2739 35.5022 16.0017 35.9678 15.821C36.4324 15.6392 36.918 15.5483 37.4235 15.5483C38.7775 15.5483 39.7534 16.0226 40.35 16.9698C40.9461 17.9181 41.2447 19.1986 41.2447 20.8119C41.2447 21.8203 41.1179 22.6922 40.8654 23.4278C40.6124 24.1645 40.2688 24.7742 39.8341 25.258C39.3998 25.7423 38.8792 26.1012 38.2726 26.3321C37.666 26.5641 36.9992 26.6801 36.2711 26.6801C35.6237 26.6801 35.0983 26.6493 34.6939 26.5892ZM48.129 15.6693H46.1574C46.1171 15.5079 46.0867 15.3214 46.0668 15.1098C46.0463 14.8982 46.0364 14.6913 46.0364 14.4896C46.0364 14.2885 46.0463 14.0811 46.0668 13.8695C46.0867 13.6579 46.1171 13.4714 46.1574 13.3094H51.0713V28.8282C50.8481 28.8679 50.6009 28.8977 50.328 28.9181C50.0551 28.9379 49.8068 28.9484 49.5847 28.9484C49.3825 28.9484 49.1447 28.9379 48.8723 28.9181C48.5989 28.8977 48.3511 28.8679 48.129 28.8282V15.6693ZM65.2339 19.5718C65.2339 19.0071 65.1579 18.4679 65.0065 17.9528C64.8546 17.4387 64.632 16.9904 64.3392 16.607C64.0453 16.224 63.6719 15.9163 63.2167 15.6848C62.762 15.4529 62.2209 15.3364 61.5944 15.3364C60.3609 15.3364 59.4159 15.7099 58.7585 16.456C58.1017 17.202 57.7025 18.2407 57.5606 19.5718H65.2339ZM72.1499 13.2192C71.9477 13.2396 71.7351 13.2699 71.513 13.3096V28.8279C71.7555 28.8676 72.0132 28.8979 72.2866 28.9183C72.5595 28.9382 72.8068 28.9486 73.0299 28.9486C73.2515 28.9486 73.4998 28.9382 73.7722 28.9183C74.0451 28.8979 74.2928 28.8676 74.5154 28.8279V21.114C74.5154 20.0659 74.6317 19.2086 74.8643 18.5435C75.0964 17.8779 75.4101 17.3534 75.804 16.9699C76.1984 16.5869 76.6426 16.32 77.1387 16.1685C77.6342 16.0175 78.1549 15.9417 78.7007 15.9417H79.1098C79.2816 15.9417 79.4482 15.9621 79.6105 16.0018C79.6509 15.7604 79.6865 15.5081 79.7169 15.2458C79.7467 14.9841 79.7619 14.7317 79.7619 14.4898C79.7619 14.2678 79.752 14.0562 79.7315 13.8545C79.7116 13.6534 79.6807 13.4611 79.6409 13.2793C79.5199 13.26 79.3722 13.2448 79.2009 13.2344C79.0291 13.2239 78.862 13.2192 78.7007 13.2192C77.6085 13.2192 76.7144 13.4716 76.0167 13.9752C75.3195 14.4794 74.758 15.075 74.3337 15.7604C74.3337 15.4172 74.3028 14.9992 74.2425 14.5045C74.1818 14.0113 74.121 13.6121 74.0608 13.3096C73.8785 13.2699 73.6763 13.2396 73.4542 13.2192C73.2311 13.1994 73.009 13.1889 72.7869 13.1889C72.5643 13.1889 72.3516 13.1994 72.1499 13.2192ZM50.0343 6.08373C50.1589 5.75355 50.2276 5.39671 50.2276 5.02368V5.01898C50.2276 4.64595 50.1589 4.2886 50.0343 3.95893C49.7037 3.83459 49.3455 3.76615 48.9715 3.76615H48.9667C48.5927 3.76615 48.2345 3.83459 47.9034 3.95893C47.7793 4.2886 47.7106 4.64595 47.7101 5.01898V5.02368C47.7106 5.39671 47.7793 5.75407 47.9039 6.08373C48.2345 6.20808 48.5927 6.27652 48.9667 6.27652H48.9715C49.3455 6.27652 49.7037 6.20808 50.0343 6.08373Z"
                    ></path>
                </svg>
            </div>

            <p class="text">Connect your apps and automate workflows with Zapier.</p>
            <v-btn class="mb-2" outlined color="indigo" @click="updateZapier"> Generate API Key </v-btn>

            <div class="connection-entry" @click="copyText(zapier.api_key)" v-if="zapier.api_key">
                <span class="entry-title">API KEY</span>
                <div class="content">
                    {{ zapier.api_key }}
                    <v-icon slot="append" class="icon">mdi-clipboard</v-icon>
                </div>
            </div>
        </v-form> -->
    </div>
</template>

<script>
import moment from 'moment';
import { SettingsIcon } from 'vue-feather-icons';
import { mapActions } from 'vuex';

export default {
    components: { SettingsIcon },
    props: {
        token: {
            type: String,
            default: '',
        },
        funeralHomeId: {
            type: Number,
            default: '',
        },
    },
    data() {
        return {
            settings: {},
            loading: true,
            hasMemoryShareAPIKey: false,
            linkedPassare: false,
            passareModal: false,
            passareDisconnectModal: false,
            organizationList: [],
            organizationListHeaders: [],
            selectedOrganization: '',
            msModal: false,
            facebookLink: false,
            facebookModal: false,
            disconnectFacebookModal: false,
            users: [],
            tempDefaultUser: null,
            rules: {
                required: value => !!value || 'Required.',
            },
            passare: {
                passareOrganizationName: '',
                passareOrganizationId: '',
                passareToken: '',
                syncPassare: false,
                lastSyncDate: '',
                totalServices: 0,
            },
            importPassareEvents: false,
            zapier: {
                api_key: '',
            },
            msApiKey: '',
            facebook: {
                facebookRtmps: '',
                facebookStreamKey: '',
            },
            hubspot: {
                hubspotCompanyID: '',
            },
            tempFacebookRtmps: '',
            tempFacebookStreamKey: '',
            formIsValid: false,
            settingsMounted: false,
            rtmpRule: [
                v => !!v || 'This field is required',
                v => v.startsWith('rtmps://') || 'URL must start with rtmps://',
            ],
            funeralHome: null,
        };
    },
    methods: {
        ...mapActions(['showSnackbar']),
        submit() {
            // const isValid = this.$refs.form.validate();
            return updateIntegrations();
        },
        requestKey() {
            const email = encodeURIComponent(this.$auth.user.email);
            window.open(
                `https://share.hsforms.com/1osIDBBK1Q82whijMoQX3KA2d2nt?email=${email}&firstname=${this.$auth.user.given_name}&lastname=${this.$auth.user.family_name}&company=${this.settings.name}&legacy=MemoryShare`,
                '_blank',
            );
        },
        getFullName(item) {
            return item.firstName + ' ' + item.lastName;
        },

        getUserSettings() {
            this.axios
                .create({ headers: { Authorization: `Bearer ${this.token}` } })
                .get(process.env.VUE_APP_API + `/FuneralHomes/${this.funeralHomeId}`)
                .then(response => {
                    this.settings = response.data.funeralHome;
                    this.tempDefaultUser = this.settings.defaultUser;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        disconnectFacebookLink() {
            const data = {
                facebookRtmps: this.tempFacebookRtmps,
                facebookStreamKey: '',
            };

            this.axios
                .create({ headers: { Authorization: `Bearer ${this.token}` } })
                .post(process.env.VUE_APP_API + `/Integration/Facebook/settings/${this.funeralHomeId}`, data)
                .then(response => {
                    this.showSnackbar({ message: 'Succesfully disconnected facebook stream link' });
                    this.disconnectFacebookModal = false;
                    this.getIntegrations();
                    this.facebookLink = false;
                    this.tempFacebookStreamKey = '';
                })
                .catch(error => {
                    console.log(error);
                    this.showSnackbar({ message: 'Error disconnecting' });
                    this.disconnectFacebookModal = false;
                });
        },
        linkOrganization(item) {
            const data = {
                funeralHomeId: this.funeralHomeId,
                passareOrganizationId: item.value,
                passareOrganizationName: item.text,
                passareToken: this.passare.passareToken,
            };

            this.axios
                .create({ headers: { Authorization: `Bearer ${this.token}` } })
                .put(process.env.VUE_APP_API + `/Integration/Passare/settings`, data)
                .then(response => {
                    this.showSnackbar({ message: 'Succesfully linked passare' });
                    this.passareModal = false;
                    this.getIntegrations();
                    this.organizationList = [];
                })
                .catch(error => {
                    console.log(error);
                    this.passareModal = false;
                    if ((error.response.data = 'This organization ID is already used with another funeral home')) {
                        this.showSnackbar({ message: error.response.data });
                    } else {
                        console.log(error);
                        this.showSnackbar({ message: 'Error linking to passare' });
                    }
                });
        },
        disconnectPassare() {
            this.axios
                .create({ headers: { Authorization: `Bearer ${this.token}` } })
                .put(process.env.VUE_APP_API + `/Integration/Passare/clear-api-key/${this.funeralHomeId}`)
                .then(response => {
                    this.showSnackbar({ message: 'Succesfully disconnected from passare' });
                    this.passareDisconnectModal = false;
                    this.linkedPassare = false;
                    this.getIntegrations();
                })
                .catch(error => {
                    this.showSnackbar({ message: 'Error diconnecting from passare' });
                });
        },
        checkAPIKey(value) {
            const apikey = value;
            this.axios
                .create({
                    headers: { Authorization: `Bearer ${this.token}` },
                })
                .post(
                    process.env.VUE_APP_API +
                        `/Integration/Passare/populate-org-id?FuneralHomeId=${this.funeralHomeId}&ApiKey=${apikey}`,
                )
                .then(response => {
                    if (response.data.length === 1) {
                        this.showSnackbar({ message: 'Successfuly linked passare' });
                        this.passareModal = false;
                        this.getIntegrations();
                    } else if (response.data.length > 1) {
                        this.organizationList = response.data.map(org => {
                            return {
                                text: org.organization_name,
                                value: org.organization_uuid,
                            };
                        });
                        this.organizationListHeaders = [
                            { text: 'Account', value: 'text' },
                            { text: 'ID', value: 'value' },
                        ];
                    }
                })
                .catch(error => {
                    console.log(error.response.data);
                    if (error.response.data === 'Invalid API Key') {
                        this.showSnackbar({ message: error.response.data });
                    } else {
                        this.showSnackbar({ message: 'Error connecting to passare' });
                    }
                    this.passareModal = false;
                });
        },
        copyText(text) {
            const el = document.createElement('textarea');
            el.value = text;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            this.showSnackbar({ message: 'Copied to clipboard!' });
        },
        getIntegrations() {
            this.loading = true;
            const instance = this.axios.create({ headers: { Authorization: `Bearer ${this.token}` } });
            const passareRequest = instance.get(this.passareEndpoint + `/${this.funeralHomeId}`);
            const passareInfoRequest = instance.get(this.passareInfoEndpoint);
            const facebookRequest = instance.get(this.facebookEndpoint);
            // const zapierRequest = instance.get(this.zapierEndpoint + `/apikey`);
            const hubspotRequest = instance.get(this.hubspotEndpoint);
            const requests = [
                passareRequest,
                passareInfoRequest,
                facebookRequest,
                // zapierRequest,
                hubspotRequest,
            ];
            if (this.$auth.role.includes('SuperAdmin')) {
                // const hubspotRequest = instance.get(this.hubspotEndpoint);
                // requests.push(hubspotRequest);
            }

            Promise.allSettled(requests)
                .then(
                    ([
                        passareRes,
                        passareInfoRes,
                        facebookRes,
                        // zapierRes,
                        hubspotRes,
                    ]) => {
                        // Handle Passare response
                        if (passareRes.status === 'fulfilled') {
                            const {
                                passareOrganizationId,
                                passareToken,
                                syncPassare,
                                passareOrganizationName,
                                importPassareEvents,
                            } = passareRes.value.data;
                            this.passare.passareOrganizationId = passareOrganizationId;
                            this.passare.passareOrganizationName = passareOrganizationName;
                            this.passare.passareToken = passareToken;
                            this.passare.syncPassare = syncPassare;
                            if (this.passare.passareOrganizationId) {
                                this.linkedPassare = true;
                            }
                            this.importPassareEvents = importPassareEvents;
                        } else {
                            this.showSnackbar({ message: `There was an error retrieving your Passare settings.` });
                        }

                        //Handle Passare Info Endpoint(not settings) response
                        if (passareInfoRes.status === 'fulfilled') {
                            if (passareInfoRes.value.data[0].lastSyncDate) {
                                this.passare.lastSyncDate = moment(passareInfoRes.value.data[0].lastSyncDate).format(
                                    'l',
                                );
                            }
                            this.passare.totalServices =
                                passareInfoRes.value.data[0].totalServices.toLocaleString('en-US');
                        }

                        // Handle Facebook response
                        if (facebookRes.status === 'fulfilled') {
                            const { facebookRtmps, facebookStreamKey } = facebookRes.value.data;
                            this.facebook.facebookRtmps = facebookRtmps;
                            this.facebook.facebookStreamKey = facebookStreamKey;
                            this.tempFacebookRtmps = facebookRtmps;

                            if (this.facebook.facebookStreamKey) {
                                // this.tempFacebookRtmps = facebookRtmps;
                                this.tempFacebookStreamKey = facebookStreamKey;

                                this.facebookLink = true;
                            }
                        } else {
                            this.showSnackbar({ message: 'There was an error retrieving your Facebook settings.' });
                        }

                        // // Handle Zapier response
                        // if (zapierRes.status === 'fulfilled') {
                        //     this.zapier.api_key = zapierRes.value.data.api_key;
                        // } else {
                        //     this.showSnackbar({ message: 'There was an error retrieving your Zapier settings.' });
                        // }

                        // Handle Hubspot response
                        if (hubspotRes.status === 'fulfilled') {
                            this.hubspot.hubspotCompanyID = hubspotRes.value.data.hubspotCompanyID;
                        } else {
                            this.showSnackbar({ message: 'There was an error retrieving your Hubspot settings.' });
                        }
                    },
                )
                .finally(() => {
                    this.loading = false;
                    this.settingsMounted = true;
                });
        },
        updatePassare() {
            this.loading = true;

            this.axios
                .create({ headers: { Authorization: `Bearer ${this.token}` } })
                .put(this.passareEndpoint, { funeralHomeId: this.funeralHomeId, ...this.passare })
                .then(response => {
                    this.showSnackbar({ message: 'Settings successfully updated' });
                })
                .catch(error => {
                    console.dir(error);
                    this.showSnackbar({ message: 'Error! Please try again' });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        updateFacebook() {
            if (this.formIsValid) {
                this.loading = true;
                if (this.tempFacebookRtmps && this.tempFacebookStreamKey) {
                    this.facebook.facebookRtmps = this.tempFacebookRtmps;
                    this.facebook.facebookStreamKey = this.tempFacebookStreamKey;
                }

                this.axios
                    .create({ headers: { Authorization: `Bearer ${this.token}` } })
                    .post(this.facebookEndpoint, this.facebook)
                    .then(response => {
                        this.showSnackbar({ message: 'Settings successfully updated' });
                    })
                    .catch(error => {
                        this.showSnackbar({ message: 'Error! Please try again ' });
                    })
                    .finally(() => {
                        this.loading = false;
                        this.facebookModal = false;
                        this.getIntegrations();
                    });
            }
        },
        updateZapier() {
            this.loading = true;
            this.axios
                .create({ headers: { Authorization: `Bearer ${this.token}` } })
                .post(this.zapierEndpoint + '/generate-apikey', this.zapier)
                .then(({ data }) => {
                    this.zapier.api_key = data.api_key;
                    this.showSnackbar({ message: 'Zapier key successfully generated!' });
                })
                .catch(error => {
                    this.showSnackbar({ message: 'Error! Please try again' });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        updateHubspot() {
            this.loading = true;
            this.axios
                .create({ headers: { Authorization: `Bearer ${this.token}` } })
                .post(this.hubspotEndpoint, this.hubspot)
                .then(({ data }) => {
                    this.showSnackbar({ message: 'Hubspot Company ID successfully updated!' });
                })
                .catch(error => {
                    this.showSnackbar({ message: 'Error updating Hubspot Company ID! Please try again.' });
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getUsers(id) {
            this.axios
                .create({ headers: { Authorization: `Bearer ${this.token}` } })
                .get(process.env.VUE_APP_API + `/Users?funeralHomeId=${id}&quick=true`)
                .then(res => {
                    if (res.data) this.users = res.data;
                })
                .catch(error => {
                    console.log(error, 'error');
                });
        },
        updatePassareImportSetting() {
            this.loading = true;

            this.axios
                .create({ headers: { Authorization: `Bearer ${this.token}` } })
                .post(process.env.VUE_APP_API + `/Integration/Passare/import-settings`, {
                    funeralHomeId: this.funeralHomeId,
                    importPassareEvents: this.importPassareEvents,
                })
                .then(response => {
                    // this.showSnackbar({ message: 'Settings successfully updated' });
                })
                .catch(error => {
                    console.dir(error);
                    this.showSnackbar({ message: 'Error! Please try again' });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getMemoryShareAPIKey() {
            this.axios
                .create({ headers: { Authorization: `Bearer ${this.token}` } })
                .get(process.env.VUE_APP_API + `/funeralhomes/api/get/${this.funeralHomeId}`)
                .then(response => {
                    this.hasMemoryShareAPIKey = response.data !== null;
                    this.msApiKey = response.data;
                })
                .catch(error => {
                    console.log(error);
                    this.hasMemoryShareAPIKey = false;
                });
        },
        generateMemoryShareAPIKey() {
            this.loading = true;

            this.axios
                .create({ headers: { Authorization: `Bearer ${this.token}` } })
                .post(process.env.VUE_APP_API + `/funeralhomes/api/generate/${this.funeralHomeId}`)
                .then(response => {
                    this.hasMemoryShareAPIKey = true;
                    this.msApiKey = response.data;
                    this.showSnackbar({ message: 'API key successfully generated!' });
                    this.msModal = false;
                })
                .catch(error => {
                    console.error(error);
                    this.showSnackbar({ message: 'Error generating API key. Please try again.' });
                    this.msModal = false;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        revokeMemoryShareAPIKey() {
            this.loading = true;

            this.axios
                .create({ headers: { Authorization: `Bearer ${this.token}` } })
                .post(process.env.VUE_APP_API + `/funeralhomes/api/revoke/${this.funeralHomeId}`)
                .then(response => {
                    this.msApiKey = null;
                    this.hasMemoryShareAPIKey = false;
                    this.showSnackbar({ message: 'API key successfully revoked!' });
                })
                .catch(error => {
                    console.error(error);
                    this.showSnackbar({ message: 'Error revoking API key. Please try again.' });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getFuneralHome() {
            this.axios
                .create({ headers: { Authorization: `Bearer ${this.token}` } })
                .get(process.env.VUE_APP_API + `/funeralhomes/${this.funeralHomeId}`)
                .then(response => {
                    this.funeralHome = response.data;
                })
                .catch(error => {
                    console.error(error);
                    this.showSnackbar({ message: 'Error fetching funeral home data' });
                });
        },
    },
    watch: {
        importPassareEvents() {
            if (!this.loading && this.passare.passareOrganizationId != null && this.settingsMounted) {
                this.updatePassareImportSetting();
            }
        },
    },
    computed: {
        updateDisabled() {
            return (
                this.facebook.facebookRtmps == this.tempFacebookRtmps &&
                this.facebook.facebookStreamKey == this.tempFacebookStreamKey
            );
        },
    },
    created() {
        this.passareInfoEndpoint = process.env.VUE_APP_API + `/Integration/Passare/info/${this.funeralHomeId}`;
        this.passareEndpoint = process.env.VUE_APP_API + `/Integration/Passare/settings`;
        this.facebookEndpoint = process.env.VUE_APP_API + `/Integration/Facebook/settings/${this.funeralHomeId}`;
        this.zapierEndpoint = process.env.VUE_APP_API + `/Integration/Zapier/settings/${this.funeralHomeId}`;
        this.hubspotEndpoint = process.env.VUE_APP_API + `/Integration/Hubspot/settings/${this.funeralHomeId}`;
        this.getIntegrations();
        this.getUserSettings();
        this.getUsers(this.$route.params.id);
        this.getMemoryShareAPIKey();
        this.getFuneralHome();
    },
};
</script>

<style lang="scss" scoped>
.btn:hover {
    cursor: pointer;
}
.facebook-logo {
    width: 50px;
}
.sync-info {
    border: 2px solid #eee;
    margin: 25px;
    padding: 10px;
    border-radius: 10px;
}

// For Hubspot logo
.cls-1 {
    fill: none;
}
.cls-2 {
    clip-path: url(#clip-path);
}
.cls-3 {
    fill: #33475b;
}
.cls-4 {
    clip-path: url(#clip-path-3);
}
.cls-5 {
    fill: #ff7a59;
}
.hubspot-logo {
    width: 100px;
    margin-bottom: 1rem;
}
.get-started-div {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 200px;
    height: 150px;
    padding: 30px;
    border: 1px solid rgba(128, 128, 128, 0.651);
    border-radius: 5px;
    transition: 0.3s;
}

.get-started-div:hover {
    border: 1px solid #1976d2;
    transition: 0.3s;
    cursor: pointer;

    box-shadow: 0px 6px 11px -1px rgba(0, 0, 0, 0.2);
}
#facebookCard {
    margin: 10px;
    box-shadow: 0px 6px 11px -1px rgba(0, 0, 0, 0.2);
    border: 2px solid #1877f2;
    border-radius: 15px;
    padding: 15px;
    // background-color: #ecf3fb;
    .input-div {
        display: flex;
        flex-direction: column;
    }
    .button-div {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        gap: 20px;
    }
}

.beta-badge {
    margin-top: -20px;
    margin-left: 120px;
    margin-bottom: 0;
    padding: 3px;
    color: white;
    background-color: #ff9469;
    border-radius: 10px;
    z-index: 1;
}
.coming-soon-badge {
    margin-top: -20px;
    margin-left: 120px;
    margin-bottom: 10px;
    padding: 3px;
    color: white;
    background-color: #79bbee;
    border-radius: 10px;
    z-index: 1;
    min-width: 105px;
}
.connection-entry {
    width: 100%;
    position: relative;
    cursor: pointer;
    margin: 1rem 0;

    .entry-title {
        size: 0.75rem;
        color: gray;
    }

    .content {
        background: rgb(231, 231, 231);
        padding: 0.5rem;
        border-radius: 4px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding-right: 3rem;
    }
    .icon {
        position: absolute;
        right: 10px;
        cursor: pointer;
    }
}

#tukiosCard {
    margin: 10px;
    box-shadow: 0px 6px 11px -1px rgba(0, 0, 0, 0.2);
    // border: 2px solid #9bca52;
    border: 2px solid #ff530d;
    border-radius: 15px;
    padding: 15px;
    // background-color: #ecf3fb;
    .logo-div {
        display: flex;
        justify-content: center;
    }
}
#passareCard {
    margin: 10px;
    box-shadow: 0px 6px 11px -1px rgba(0, 0, 0, 0.2);
    border: 2px solid #005069;
    border-radius: 15px;
    padding: 15px;
    .logo-div {
        display: flex;
        justify-content: center;
    }
}

@media only screen and (min-width: 768px) {
    #tukiosCard {
        .logo-div {
            justify-content: flex-start;
        }
    }
    #passareCard {
        display: flex;

        .img-div {
            width: 30%;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        .input-div {
            flex-grow: 1;

            display: flex;
            flex-direction: row;
            justify-content: space-around;
        }
        .text-div {
            padding: 10px;
            // padding-top: 30px;
            width: 70%;
        }

        .button-div {
            display: flex;
            display: flex;
            flex-direction: column;
            justify-content: center;

            height: 100%;
        }
    }

    #facebookCard {
        display: flex;
        .input-div {
            flex-grow: 1;
            padding: 0 20px;

            display: flex;
            flex-direction: row;
            justify-content: space-around;
        }
        .text-div {
            padding: 10px;
            padding-top: 30px;
            width: 70%;
        }

        .button-div {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
        }
    }
}
</style>
